.info-modal{
  .modal-backdrop {
    display: flex !important;
    .modal-dialog {
      margin: auto;
      .modal-content {
        border-radius: 5px !important;
        border-width: 0 !important;
        .modal-header {
          background: #687a88;
          padding-top: 8px;
          padding-bottom: 8px;
          border-bottom: 0;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          .modal-title {
            color: white;
            text-align: center;
          }
        }
        .modal-body{
          color: black;
          border-right: 2px solid #3B4655;
          border-left: 2px solid #3B4655;
          .header-1{
            font-family: "Solomon_Black";
          }
          .header-2{
            font-family: 'Solomon_Bold';
            font-weight: bold;
          }
          .text{
            opacity: .8;
            font-size: 18px;
          }
          .note-container{
            border: 2px solid #d2d9e9;
            border-radius: 5px;
            padding: 10px;
            .note{
              color:red;
            }
            .note-text{
              font-style: italic;
            }
          }
        }
        .modal-footer{
          background: #687a88;
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
          padding-top: 8px;
          padding-bottom: 8px;
          border-top-width: 0;
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/info-modal/info-modal.scss